export const TAGS = [
    { id: 'striking_distance', label: 'Striking distance' },
    { id: 'keyword_clusters', label: 'Keyword Clusters' },
    { id: 'directories', label: 'Directories' },
    { id: 'evergreen', label: 'Evergreen' },
    { id: 'year', label: 'Year' },
];
